import React from 'react';
import styles from './Alerts.module.scss';
import { useDispatch, useSelector } from "react-redux";
import { removeAlert } from "../../../store/alerts-slice";
import { $t } from "../../../helpers/translator";
import { IoCheckmarkCircleOutline, IoClose, IoInformationCircleOutline, IoWarningOutline } from "react-icons/io5";

const Alerts = () => {
    const dispatch = useDispatch();
    const alerts = useSelector(state => state.alerts.alerts)

    async function removeAlertFromArray(personalKey) {
        dispatch(removeAlert(personalKey));    //removes alert from store
    }

    return (
        <div className={ styles.toastContainer }>
            { alerts.map((v, k) => (
                <div key={ k }>

                    <div key={ k } className={ `${styles.alert} 
                        ${(!v.display ? styles.hidden : null)}
                        ${(v.type === 'success' ? styles.successColors : null)}
                        ${(v.type === 'info' ? styles.infoColors : null)}
                        ${(v.type === 'warning' ? styles.warningColors : null)}
                        ${(v.type === 'error' ? styles.dangerColors : null)}` }>

                        { v.hideClose ?
                            null
                            :
                            <div className={ styles.closeButton }
                                onClick={ async () => removeAlertFromArray(v.key) }>
                                <IoClose />
                            </div>
                        }

                        <div className={ styles.alertHead }>
                            <div className={ styles.alertIcon }>
                                { v.type === 'success' && <IoCheckmarkCircleOutline /> }
                                { v.type === 'error' && <IoInformationCircleOutline /> }
                                { v.type === 'warning' && <IoWarningOutline /> }
                                { v.type === 'info' && <IoInformationCircleOutline /> }
                            </div>

                            <div>
                                { v.header ? v.header : $t('global.alerts.' + v.type) }
                            </div>

                        </div>
                        { v.body ?
                            <div className={ styles.alertBody }>
                                { v.body }
                            </div>
                            :
                            null
                        }
                    </div>
                </div>

            ))
            }
        </div>
    )
}

export default Alerts;
